<div id="promoContent" class="d-flex flex-column h-100">
  <div id="profileText" class="profile-text" *ngIf="presentPage === profilePage">
    <div id="profileNameTitle" class="profile-name-title">{{profileNameValue}}</div>
    <h2 class="profile-name-text">{{profileDataResponse?.profileName}}</h2>
  </div> 
  <div id="livePreview" class="al_live_preview" [ngClass]="[tabIndex === 1 ? 'promo-content_al_live_preview': '']"
    [ngClass]="tabIndex === 2 || tabIndex === 3 || tabIndex === 4 ? 'preview_padding' : ''">
    <iposcen-content-live-preview *ngIf="(presentPage === profilePage && (tabIndex === 0 || tabIndex === 1))"
      [sidenav]="pageType" [enableAIIPOSPreview]="false"></iposcen-content-live-preview>
    <div id="promotionalContent" class="d-flex promo-Content-Live" *ngIf="presentPage=== assetsPage && tabIndex === 1">
      <div id="previewContainer" class="preview__container" *ngIf="activePreviewTab == 'Panther' || previousSelectedTab == 'Panther'">
        <img class="evo_promo_Preview" src="assets/images/ptl-promo-preview.gif" alt="evo promo preview"/>
        <label class="promo-label promo-content_promo-label lunar-ptl-promotional-text">
          <span>{{globConst.CONTENT_PREVIEW_PROMOTIONAL_CONTENT}}</span>
        </label>
      </div>
      <div id="previewContainer" class="preview__container" *ngIf="activePreviewTab == 'Lunar' || previousSelectedTab == 'Lunar'">
        <img class="evo_promo_Preview" src="assets/images/lunar_lake_proc.gif" alt="evo promo preview"/>
        <label class="promo-label promo-content_promo-label lunar-ptl-promotional-text">
          <span>{{globConst.CONTENT_PREVIEW_PROMOTIONAL_CONTENT}}</span>
        </label>
      </div>
      <div id="previewContainer" class="preview__container" *ngIf="activePreviewTab == 'CoreUltra' || previousSelectedTab == 'CoreUltra'">
        <img class="evo_promo_Preview" src="assets/images/evo_preview_promo.png" alt="evo promo preview"
          *ngIf="enableAIIPOSPreview" />
        <img class="evo_promo_Preview" src="assets/images/core_ultra_proc.gif" alt="ai promo preview"
          *ngIf="!enableAIIPOSPreview" />
        <label class="promo-label promo-content_promo-label">
          <!-- <span i18n="@@content-live-preview.new-promo-preview.promo-new-preview-txt">The placement of <strong>Promotional Content Groups</strong> on Intel® Evo™ Platform and non-gaming devices with Intel® Core™ Ultra Processors, that can be accessed from Fact Tags.</span> -->
          <span i18n="@@content-live-preview.new-promo-preview.promo-aiipos-preview-txt">The placement of the
            <strong>Promotional</strong> Content Groups on devices that have Intel® Core™ Ultra processors with AI
            Capabilities.</span>
        </label>
      </div>
      <div class="non_evo_preview_preview_container" *ngIf="activePreviewTab == 'CoreProcessor' || previousSelectedTab == 'CoreProcessor'">
        <div id="previewInnerContainer" class="non_evo_preview__innercontainer">
          <img class="non_evo_promo_Preview" src="assets/images/Promotional_Content_Preview.png" alt="promo preview" />
        </div>
        <div class="preview-border-txt">
          <label>
            <!-- <span i18n="@@content-live-preview.old-promo-preview.promo-old-preview-txt">The placement of the Promotional Content Groups on devices with a Intel® Core™ processor (14th, 13th, 12th Gen), will be displayed on the Store Promotions page.</span> -->
            <span i18n="@@content-live-preview.old-promo-preview.promo-aiipos-small-preview-txt">The placement of the
              Promotional Content Groups on devices with an Intel® Core™ processor (14th, 13th, 12th Gen), will be
              displayed on the Store Promotions page.</span>
          </label>
        </div>
      </div>

  <!-- Preview container specifies size of preview window -->
  <div class="preview_list">
    <h4>{{globConst.CONTENT_PREVIEW_SELECT_INTEL_PROCESSOR_GEN}}</h4>
    <div class="list" role="list">
      <div class="list-item active" [ngClass]="{'active': (activePreviewTab == 'Panther')}"
        (click)="selectPreviewTab('Panther')">{{globConst.CONTENT_PREVIEW_PTL}}</div>
      <div class="list-item active" [ngClass]="{'active': (activePreviewTab == 'Lunar')}"
        (click)="selectPreviewTab('Lunar')">{{globConst.CONTENT_PREVIEW_LNL}}</div>
      <div class="list-item" [ngClass]="{'active': (activePreviewTab == 'CoreUltra')}"
        (click)="selectPreviewTab('CoreUltra')">{{globConst.CONTENT_PREVIEW_CORE_ULTRA}}</div>
      <div class="list-item" [ngClass]="{'active': (activePreviewTab == 'CoreProcessor')}"
        (click)="selectPreviewTab('CoreProcessor')">{{globConst.CONTENT_PREVIEW_CORE_12TH_13TH_14TH_GEN}}</div>
      <div class="list-item" [ngClass]="{'active': (activePreviewTab == 'Evo')}"
        (click)="openPreviewPopup(popupPreview)">{{globConst.CONTENT_PREVIEW_CORE_11TH_12TH_13TH_14TH_AND_1ST_GEN}}</div>
    </div>
  </div>
    </div>
    <!-- Live preview - temporarly image -->
    <iposcen-live-preview [sidenav]="pageType"
      *ngIf="tabIndex === 2 || tabIndex === 3 || tabIndex === 4"></iposcen-live-preview>
    <!-- Layout of preview -->
    <div id="layout" class="preview_layout" *ngIf="tabIndex === 2 || tabIndex === 3 || tabIndex === 4">
      <div *ngIf="showPreviewLayout">
        <div id="LCG1" class="card">
          <img [ngClass]="(lCGlayout === 1) ? 'img_layout-selected1': 'img_layout1'" alt="layout 1"
            (click)="setLayout(1)" class="cursor-pointer" />
        </div>
        <div id="LCG2" class="card">
          <img [ngClass]="(lCGlayout === 2) ? 'img_layout-selected2': 'img_layout2'" alt="layout 2"
            (click)="setLayout(2)" class="cursor-pointer" />
        </div>
        <div id="LCG3" class="card">
          <img [ngClass]="(lCGlayout === 3) ? 'img_layout-selected3': 'img_layout3'" alt="layout 3"
            (click)="setLayout(3)" class="cursor-pointer" />
        </div>
      </div>
    </div>
  </div>
  <!-- new part-->
  <!-- <div class="clickSection d-flex" *ngIf="presentPage=== assetsPage && tabIndex === 1">
    <a class="cursor-pointer" (click)="openPreviewPopup(popupPreview)">
      <span>Preview of 11th, 12th, 13th, 14th Gen and 1st Gen RPL Refresh Intel® Evo™ Platform Devices. &nbsp;
        <img src="assets/images/popup387.png" alt="popup icon" />
      </span>
    </a>
  </div> -->
  <ng-template #popupPreview let-modal>
    <div id="confrmPopUp" class="card confirmPopup">
      <div class="close" (click)="closePromoModal()" id="duplicateClose">
        <img alt="close" class="modal-close-icon">
      </div>
      <div id="modalBody" class="modal-body popup-body">
        <div id="previewContainer2">
          <img class="evo_promo_Preview" src="assets/images/evo_preview_promo.png" alt="evo promo preview" />
          <label class="promo-label promo-content_promo-label">
            <span i18n="@@content-live-preview.old-promo-preview.promo-aiipos-popup-preview-txt">The placement of the
              <strong>Promotional</strong> Content Groups on devices supporting the Intel® Evo™ platform. The
              Promotional content appears in the home page of IPOS.</span>
          </label>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- new part-->

  <ul *ngIf="(tabIndex === 1 || tabIndex === 2 || tabIndex === 3 || tabIndex === 4)" class="nav nav-tabs"
    role="tablist">
    <li class="nav-item">
      <a class="nav-link gtmAssetLibraryPromoContentTitle" data-toggle="tab" [ngClass]="{'active': tabIndex === 1}"
        (click)="navigate()">
        <span placement="top" ngbTooltip="{{editCheck?showPromoContentName + details:newPromoContentTitle}}"
          tooltipClass="tooltip-width"> {{editCheck? tabTrimString(showPromoContentName) :
          tabTrimString(newPromoContentTitle) }}</span>
      </a>
    </li>
    <li class="nav-item" *ngIf="pages && pages.page1">
      <a class="nav-link gtmAssetLibraryPromoContentPage1" data-toggle="tab" [ngClass]="{'active': tabIndex === 2}"
        (click)="clickable?setIndex(2):false"><span i18n="@@global.tab-nav.page1">PAGE 1</span></a>

      <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
      <!-- <a class="nav-link gtmAssetLibraryPromoContentPage1" data-toggle="tab" [ngClass]="{'active': tabIndex === 2}"
        (click)="clickable?setIndex(2):false">
        <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page1">PAGE 1</span>&nbsp;</div>
          <div class="delete_page" *ngIf="pagelen > 1" (click)="clickable?openPopupPromo(delete,0):false"></div>
        </div>
      </a> -->
    </li>
    <li class="nav-item" *ngIf="pages && pages.page2">
      <a class="nav-link gtmAssetLibraryPromoContentPage2" data-toggle="tab" [ngClass]="{'active': tabIndex === 3}"
        (click)="clickable?setIndex(3):false"><span i18n="@@global.tab-nav.page2">PAGE 2</span></a>

      <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
      <!-- <a class="nav-link gtmAssetLibraryPromoContentPage2" data-toggle="tab" [ngClass]="{'active': tabIndex === 3}"
        (click)="clickable?setIndex(3):false">
        <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page2">PAGE 2</span>&nbsp;</div>
          <div class="delete_page" (click)="clickable?openPopupPromo(delete,1):false"></div>
        </div>
      </a> -->
    </li>
    <li class="nav-item" *ngIf="pages && pages.page3">
      <a class="nav-link gtmAssetLibraryPromoContentPage3" data-toggle="tab" [ngClass]="{'active': tabIndex === 4}"
        (click)="clickable?setIndex(4):false"><span i18n="@@global.tab-nav.page3">PAGE 3</span></a>

      <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
      <!-- <a class="nav-link gtmAssetLibraryPromoContentPage3" data-toggle="tab" [ngClass]="{'active': tabIndex === 4}"
        (click)="clickable?setIndex(4):false">
        <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page3">PAGE 3</span>&nbsp;</div>
          <div class="delete_page" (click)="clickable?openPopupPromo(delete,2):false"></div>
        </div>
      </a> -->
    </li>
    <li class="nav-item" *ngIf="clickable && !checkPages()">
      <a class="nav-link gtmAssetLibraryPromoContentAddPage" data-toggle="tab" (click)="addPage()">
        <img src="assets/images/add_black_square_outline.svg" alt="add pages" />
      </a>
    </li>
    <li class="nav-item exit_preview" *ngIf="pages && pages.page1">
      <a class="nav-link gtmAssetLibraryPromoContentCancel" (click)="cancel();resetPage()">
        <img src="assets/images/exit_icon.svg" alt="exit without changes" />
      </a>
    </li>
  </ul>



  <!-- Main section -->
  <section *ngIf="tabIndex === 0" class="main_section al_storepromo">
    <div id="mainSection" class="d-flex flex-column h-100">
      <!-- Promo Content Group Tab -->
      <div id="promoContentTab" *ngIf="tabIndex === 0" id="promoContentGroups">
        <div id="mainSecHeaders" class="main_section_headers"
          [ngClass]="(presentPage === profilePage)?'profile_section_headers':''">
          <div id="promotionalContent" class="d-flex align-items-center">
            <img *ngIf="presentPage=== assetsPage" class="header_icon" alt="header icon" />
            <span i18n="@@promo-content.promo-content-heading">PROMOTIONAL CONTENT</span>
          </div>
          <span class="data_action" *ngIf="presentPage=== profilePage && displayPromoContentGroups?.length">
            <button type="button" id="uploadpromo"
              class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryPromoContentNewPromoContent"
              (click)="createPromo()">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 3.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H8V4C8 3.86739 8.05268 3.74021 8.14645 3.64645C8.24021 3.55268 8.36739 3.5 8.5 3.5Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8 8C8 7.86739 8.05268 7.74021 8.14645 7.64645C8.24021 7.55268 8.36739 7.5 8.5 7.5H12.5C12.6326 7.5 12.7598 7.55268 12.8536 7.64645C12.9473 7.74021 13 7.86739 13 8C13 8.13261 12.9473 8.25979 12.8536 8.35355C12.7598 8.44732 12.6326 8.5 12.5 8.5H9V12C9 12.1326 8.94732 12.2598 8.85355 12.3536C8.75979 12.4473 8.63261 12.5 8.5 12.5C8.36739 12.5 8.24021 12.4473 8.14645 12.3536C8.05268 12.2598 8 12.1326 8 12V8Z"
                    fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 15C10.3565 15 12.137 14.2625 13.4497 12.9497C14.7625 11.637 15.5 9.85652 15.5 8C15.5 6.14348 14.7625 4.36301 13.4497 3.05025C12.137 1.7375 10.3565 1 8.5 1C6.64348 1 4.86301 1.7375 3.55025 3.05025C2.2375 4.36301 1.5 6.14348 1.5 8C1.5 9.85652 2.2375 11.637 3.55025 12.9497C4.86301 14.2625 6.64348 15 8.5 15ZM8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16Z" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="16" height="16" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
              <span i18n="@@promo-content.new-promotional-content">New Promotional Content Group</span>
            </button>
          </span>
        </div>

        <!-- Data header with info like no. of content groups, action buttons and filters -->
        <div id="dataHeader" class="data_header" [ngClass]="(displayPromoContentGroups.length > 0)?'':'display-block'">
          <ng-container *ngIf="presentPage === assetsPage">
            <span *ngIf="displayPromoContentGroups?.length">
              <span *ngIf="displayPromoContentGroups && displayPromoContentGroups.length == 1"
                id="dataTitle">{{displayPromoContentGroups.length}} {{promoContentLabel}}</span>
              <span *ngIf="displayPromoContentGroups && displayPromoContentGroups.length > 1"
                id="dataTitle">{{displayPromoContentGroups.length}}
                <span i18n="@@promo-content.promo-content-grp.count.name">Promotional Content Groups</span></span>
              <span *ngIf="displayPromoContentGroups.length > 1 ">
                <span class="sort-by-label" i18n="@@promo-content.sort-by">Sort by</span>:&nbsp;
                <div id="promoDropDown" ngbDropdown class="btn-group">
                  <button ngbDropdownToggle class="btn btn-primary btn-sm dropdown-toggle"
                    id="sortDropDown">{{sortValue}}
                  </button>
                  <div id="promoDropDownMenu" class="sort-dropdown" ngbDropdownMenu aria-labelledby="sortDropDown">
                    <button ngbDropdownItem *ngIf="sortValue!=createdDateVal"
                      (click)="sortByDate()">{{createdDateVal}}</button>
                    <button ngbDropdownItem *ngIf="sortValue!=groupNameVal" (click)="sortByName()">
                      <span i18n="@@promo-content.sort.group-name">Group Name</span></button>
                  </div>
                </div>
              </span>
            </span>
            <span *ngIf="!displayPromoContentGroups?.length"
              i18n="@@promo-content.add-promo-content-sub-heading-one">Add
              Promotional Content to inform shoppers of everything
              from sales and rebates to tutorials or product demos.</span>
          </ng-container>

          <ng-container *ngIf="presentPage === profilePage && displayPromoContentGroups?.length">
            <div id="promoContentGroupsSec">
              <div id="promoContentGroupsPckg">
                <strong><span i18n="@@promo-content.add-to-package.count.name">Added to Package</span>:</strong>
                {{ selctedContGrpsForProfile.contentGrps?.length}}
                <span i18n="@@promo-content.add-to-package.count.contentgrps">Content Groups</span>
              </div>
              <div id="promoContentGroupsDevices">
                <strong><span i18n="@@promo-content.shown-on-device-label">Show on Device</span>:</strong>
                {{ selctedContGrpsForProfile.showOnDevice?.length}}
                <span i18n="@@promo-content.add-to-package.count.contentgrps">Content Groups</span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="presentPage === profilePage && !displayPromoContentGroups?.length">
            <span i18n="@@promo-content.add-promo-content-sub-heading-one">Add
              Promotional Content to inform shoppers of everything
              from sales and rebates to tutorials or product demos.</span><br />
            <strong><span>{{noPromoCreatedDescription}}</span></strong>
          </ng-container>
          <span class="data_action"
            *ngIf="presentPage === assetsPage || (presentPage === profilePage && !displayPromoContentGroups?.length)">
            <button type="button" id="uploadpromo"
              class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryPromoContentUploadPromo"
              (click)="createPromo()">
              <svg class="gtmAssetLibraryPromoContentUploadPromo" width="17" height="16" viewBox="0 0 17 16"
                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 3.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H8V4C8 3.86739 8.05268 3.74021 8.14645 3.64645C8.24021 3.55268 8.36739 3.5 8.5 3.5Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8 8C8 7.86739 8.05268 7.74021 8.14645 7.64645C8.24021 7.55268 8.36739 7.5 8.5 7.5H12.5C12.6326 7.5 12.7598 7.55268 12.8536 7.64645C12.9473 7.74021 13 7.86739 13 8C13 8.13261 12.9473 8.25979 12.8536 8.35355C12.7598 8.44732 12.6326 8.5 12.5 8.5H9V12C9 12.1326 8.94732 12.2598 8.85355 12.3536C8.75979 12.4473 8.63261 12.5 8.5 12.5C8.36739 12.5 8.24021 12.4473 8.14645 12.3536C8.05268 12.2598 8 12.1326 8 12V8Z"
                    fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 15C10.3565 15 12.137 14.2625 13.4497 12.9497C14.7625 11.637 15.5 9.85652 15.5 8C15.5 6.14348 14.7625 4.36301 13.4497 3.05025C12.137 1.7375 10.3565 1 8.5 1C6.64348 1 4.86301 1.7375 3.55025 3.05025C2.2375 4.36301 1.5 6.14348 1.5 8C1.5 9.85652 2.2375 11.637 3.55025 12.9497C4.86301 14.2625 6.64348 15 8.5 15ZM8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16Z" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="16" height="16" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
              <span i18n="@@promo-content.new-promotional-content" class="gtmAssetLibraryPromoContentUploadPromo">New
                Promotional Content Group</span>
            </button>
          </span>
        </div>
        <ng-container>
          <div id="addPromoContent" *ngIf="presentPage === profilePage && displayPromoContentGroups?.length"
            class="mt-3 mb-3">
            <span i18n="@@promo-content.add-promo-content-sub-heading-one">Add
              Promotional Content to inform shoppers of everything
              from sales and rebates to tutorials or product demos.</span><br>
            <strong>
              <span>
                {{addUptoTenPromoDescription}}
              </span>
            </strong>
          </div>
        </ng-container>
        <!-- Data Content -->
        <div id="showOnDeviceSec" class="data_content segments_only" *ngIf="displayPromoContentGroups?.length > 0"
          [ngClass]="presentPage === profilePage?'acc_table_view':''">
          <div id="showOnDeviceSelect" class="show_on_device_select" *ngIf="presentPage === profilePage">
            <div id="showOnDeviceLabel" class="small_text border-right shown-on-device-label"><span
                i18n="@@promo-content.shown-on-device-label">Show on Device</span></div>
            <div id="addPckgLabel"><span i18n="@@promo-content.add-to-package.count.contentgrps">Content Groups</span>
            </div>
          </div>
          <div class="accordion" id="logoContentAccordian">
            <!-- Group 1 -->
            <div id="promoContentGroupCard" class="card"
              *ngFor="let promoContentGroup of displayPromoContentGroups | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; index as i">
              <div id="promoContentGroupHeader" class="card-header small_text" id="segmentOne">
                <div id="promoContentAccCheck" class="acc_check" *ngIf="presentPage === profilePage">
                  <div id="promoContentCheckbox" class="form-check"
                    [ngbPopover]="((!promoContentGroup.addToPackage || selctedContGrpsForProfile.showOnDevice?.length === 3) && !selctedContGrpsForProfile.showOnDevice.includes(promoContentGroup.id)) ? (((selctedContGrpsForProfile.contentGrps?.length === 6 && !promoContentGroup.addToPackage) || promoContentGroup.addToPackage==true) ? showonDeviceLimit:showonDeviceDisabled):''"
                    [placement]="changePlacement == true ? 'left' : 'right'" triggers="mouseenter:mouseleave">
                    <input type="checkbox" name="cpLCGSelect" class="form-check-input"
                      [value]="promoContentGroup.showOnDevice" [checked]="promoContentGroup.showOnDevice"
                      (change)="addToProfile($event,promoContentGroup.index,'showondevice')" [disabled]="(!promoContentGroup.addToPackage || selctedContGrpsForProfile.showOnDevice?.length === 3) &&
                    !selctedContGrpsForProfile.showOnDevice.includes(promoContentGroup.id)" />
                  </div>
                </div>
                <div id="promoContentCardHeader" class="card-header-content">
                  <div id="promoContentTitle" class="title_left">
                    <div id="promoContentData" class="d-flex">
                      <div id="publishedName" class="title">
                        <span>{{promoContentGroup.configurations.publishedName}} &nbsp;&nbsp;</span>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div *ngIf="(promoContentGroup.isContentExpires)" id="contentExpire" class="content-expire"><img
                          class="contents-info-icon" alt="info_icon"><span>{{globConst.CONT_GRP_EXPIRED_TEXT}}</span>
                      </div>
                      <div class="d-flex" id="editBtn"
                        *ngIf="presentPage === assetsPage && ((!promoContentGroup.islocked && isStoreUser) || !isStoreUser)">
                        <button type="button" placement="bottom" ngbTooltip={{tooltipEdit}}
                          (click)="editPromo(promoContentGroup.id)" class="btn gtmEditSegment">
                          <img alt="Edit" />
                        </button>
                        <button type="button" placement="bottom" ngbTooltip={{tooltipDelete}}
                          (click)="openDeleteModal(promoContentGroup.id)" class="btn gtmDeleteSegment">
                          <img alt="Delete" />
                        </button>
                        <iposcen-delete-popup #deleteModal [contentName]="promoCGToDeleteName"
                          [buttonName]="contentGrpText" (delete)="deletePromoCG(promoCGToDelete)">
                        </iposcen-delete-popup>
                        <button type="button" *ngIf="isRetailerUser || isRegionalHQ" class="btn gtmSendPromo gtmSendBtn"
                          placement="bottom" ngbTooltip={{tooltipSend}} container="body"
                          (click)="openSendPromoContentToAccountModal(promoContentGroup?.id)">
                          <img alt="Send" />
                        </button>

                      </div>
                    </div>
                  </div>
                  <div id="otherData" class="other_data">
                    <div id="assetIDCopy">
                      <iposcen-assetid-copy [assetID]="promoContentGroup.id" *ngIf="presentPage === assetsPage">
                      </iposcen-assetid-copy>
                      <div id="subTitleGrp" class="subtitle_group">
                        <span class="subtitle">
                          <span i18n="@@promo-content.created-by-user-name">Created By</span>:
                          {{promoContentGroup?.createdByUser}}
                        </span>
                        <span class="subtitle"><span i18n="@@logo-content.logo-content-groups.last-edited-by">Last
                            Edited By</span>
                          {{promoContentGroup?.createdByUser}}:
                          {{promoContentGroup.updateTime | dateFormat: "changeToLocalTimeZone"}}</span>
                        <span class="subtitle"
                          *ngIf="presentPage === assetsPage && userRole !== 'nonConnectedUser'"><span
                            i18n="@@promo-content.pushed-to-all-device">Pushed to
                            all devices</span>:
                          {{ promoContentGroup?.ispushedToDevice ? yesLabel : noLabel}}
                        </span>
                        <span *ngIf="promoContentGroup?.configurations?.internalName"
                          class="subtitle"><span>{{internalName}}:</span>
                          {{promoContentGroup?.configurations?.internalName}}
                        </span>
                      </div>

                      <div id="addToProfileCheckbox" class="form-check mt-3" *ngIf="presentPage === profilePage"
                        [ngbPopover]="(selctedContGrpsForProfile.contentGrps?.length === 6 && !promoContentGroup.addToPackage) ? addToPackageLimit:''"
                        placement="top-left" triggers="mouseenter:mouseleave">
                        <input class="form-check-input" type="checkbox" [value]="promoContentGroup.addToPackage"
                          [checked]="promoContentGroup.addToPackage"
                          (change)="addToProfile($event,promoContentGroup.index,'addtopackage')"
                          [disabled]="selctedContGrpsForProfile.contentGrps?.length === 6 && !promoContentGroup.addToPackage"
                          [id]="'addToPackOne'+promoContentGroup.index" />
                        <label class="form-check-label" [for]="'addToPackOne'+promoContentGroup.index">
                          <span i18n="@@promo-content.profile-second-group.add-to-package">Add to Package</span>
                        </label>
                      </div>
                    </div>
                    <div id="gtmlockIcon" class="d-flex"
                      *ngIf="presentPage === assetsPage && promoContentGroup.islocked && isStoreUser">
                      <div id="gtmlockTxt" class="gtmlockIcon lock-icon">
                        <img alt="content locked" />
                        <span class="pl-1 pt-1">{{lockContentText}}</span>
                      </div>
                    </div>
                    <div id="changeLockContentStatus" class="custom-control custom-switch"
                      *ngIf="(presentPage === assetsPage) && (userRole === retailHqUser || userRole === regionalHqUser)">
                      <input type="checkbox" class="custom-control-input" [id]="'lockContent'+promoContentGroup?.id"
                        [checked]="promoContentGroup?.islocked" [value]="promoContentGroup?.islocked"
                        (click)=changeLockContentStatus(promoContentGroup?.id,$event,promoContentGroup) />
                      <label class="custom-control-label" [for]="'lockContent'+promoContentGroup?.id">
                        <span i18n="@@promo-content.lock-content-label">Lock Content</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div id="collapseBtn" class="collapse_link collapsed collapse-button {{promoContentGroup?.id}}"
                  type="button" (click)="getDetailsOfPromoCG(promoContentGroup?.id)"
                  [ngClass]="promoContentGroup.isExpanded ? 'transform-180' : ''">
                  <svg class="accordian_expanded" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                  </svg>
                </div>
              </div>
              <div id="collapseThree" class="collapse" #collapse="ngbCollapse"
                [(ngbCollapse)]="!promoContentGroup.isExpanded" aria-labelledby="logoCGThree"
                data-parent="#logoContentAccordian">
                <div id="logoContentCardBody" class="card-body"
                  [ngClass]="presentPage === profilePage?'':'card-body-asset'">
                  <div id="logoContentTable" class="table-container">
                    <table class="table-borderless" aria-describedby="Preview content">
                      <tr>
                        <th scope="col"><span i18n="@@promo-content.publish-date.time">Publishing Date and Time</span>
                        </th>
                        <th scope="col"><span i18n="@@promo-content.expire-date.time">Expiration Date and Time</span>
                        </th>
                      </tr>
                      <tr>
                        <!-- <td>{{promoContentGroup?.configurations?.publishTime | dateFormat: "24hrP"}}</td>
                        <td>{{promoContentGroup?. configurations?.expireTime | dateFormat: "24hrP"}}</td> -->

                        <td>{{promoContentGroup?. configurations?.publishTime | dateFormat: "24hrP"}}</td>
                        <td>{{promoContentGroup?. configurations?.expireTime | dateFormat: "24hrP"}}</td>
                      </tr>
                    </table>
                    <span class="duplicate-and-edit-span">
                      <button (click)="duplicateAndEditPromoContent(promoContentGroup.id)" type="button"
                        class="btn btn-primary btn-sm left_icon_btn gtmDuplicatePromo">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3 2H11C11.5304 2 12.0391 2.21071 12.4142 2.58579C12.7893 2.96086 13 3.46957 13 4V14C13 14.5304 12.7893 15.0391 12.4142 15.4142C12.0391 15.7893 11.5304 16 11 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V4C1 3.46957 1.21071 2.96086 1.58579 2.58579C1.96086 2.21071 2.46957 2 3 2V2ZM3 3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H11C11.2652 15 11.5196 14.8946 11.7071 14.7071C11.8946 14.5196 12 14.2652 12 14V4C12 3.73478 11.8946 3.48043 11.7071 3.29289C11.5196 3.10536 11.2652 3 11 3H3Z"
                            fill="white" />
                          <path
                            d="M5 0H13C13.5304 0 14.0391 0.210714 14.4142 0.585786C14.7893 0.960859 15 1.46957 15 2V12C15 12.5304 14.7893 13.0391 14.4142 13.4142C14.0391 13.7893 13.5304 14 13 14V13C13.2652 13 13.5196 12.8946 13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12V2C14 1.73478 13.8946 1.48043 13.7071 1.29289C13.5196 1.10536 13.2652 1 13 1H5C4.73478 1 4.48043 1.10536 4.29289 1.29289C4.10536 1.48043 4 1.73478 4 2H3C3 1.46957 3.21071 0.960859 3.58579 0.585786C3.96086 0.210714 4.46957 0 5 0V0Z"
                            fill="white" />
                        </svg>
                        <span i18n="@@promo-content.duplicate-and-edit">Duplicate and Edit</span>
                      </button>
                    </span>
                  </div>
                  <div id="IdleExperiencePreviewSection" class="form-group idleExperiencePreviewSection"
                    *ngIf="promoContentGroup?.configurations?.contentGroupPages?.length">
                    <form>
                      <div [ngClass]="{'width-Added-other-language': ['cs','pl'].includes(globConst.IPOS_LANGUAGE)}">
                        <input type="radio" name="ptPCGSelect" class="form-check-input"
                          value=globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS
                          (change)="togglePreviewTabs(globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS,promoContentGroup?.id)"
                          [checked]="globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS ==  promoContentGroup.isIdleExperienceEnabled" />
                        <label class="form-check-input" for="isIdleExperiencePreview">
                          {{globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS}}
                        </label>
                      </div>
                      <div>
                        <input type="radio" name="ptPCGSelect" class="form-check-input"
                          value=globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE
                          [checked]="globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE ==  promoContentGroup.isIdleExperienceEnabled"
                          (change)="togglePreviewTabs(globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE,promoContentGroup?.id)" />
                        <label class="form-check-input" for="isIdleExperiencePreview">
                          {{globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE}}
                        </label>
                      </div>
                    </form>
                  </div>
                  <div id="miniPreviewContainer" class="mini-preview-container">
                    <ng-container *ngFor="let page of promoContentGroup.configurations.contentGroupPages">
                      <!-- <div class="each-mini-preview">
                        <iposcen-live-preview [data]="loadMiniPreview(promoContentGroup.id,page)"
                          [isIdleExperienceEnable]="promoContentGroup.isIdleExperienceEnabled" [miniPreview]="true"
                          [customClass]="true">
                        </iposcen-live-preview>
                      </div> -->
                      <iposcen-mini-live-preview [data]="loadMiniPreview(promoContentGroup?.id,page)"
                        [isIdleExperienceEnable]="promoContentGroup.isIdleExperienceEnabled"></iposcen-mini-live-preview>
                    </ng-container>
                  </div>
                  <table class="table-borderless form-factors-main-div" aria-describedby="Form factors">
                    <tr>
                      <th scope="col"><span i18n="@@promo-content.content-group-applies-to">Content Group Applies
                          To</span>:</th>
                    </tr>
                    <tr>
                      <td><strong><span>{{deviceTypes}}</span>: </strong>
                        {{ promoContentGroup?.configurations?.formFactor?.devices}}</td>
                    </tr>
                    <tr>
                      <td><strong><span>{{manufacturers}}</span>: </strong>
                        {{ promoContentGroup?.configurations?.formFactor?.manufacturer}}</td>
                    </tr>
                    <tr>
                      <td><strong><span>{{processors}}</span>:</strong>
                        {{ promoContentGroup?.configurations?.formFactor?.processors}}</td>
                    </tr>
                    <tr>
                      <td><strong><span>{{generation}}</span>: </strong>
                        {{ promoContentGroup?.configurations?.formFactor?.generations}}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <iposcen-send-to-segment-account #sendToAccountModal [sendName]="sendNameToStore"
              [sendButtonName]="sendButtonText" (selectedStoreData)="getSelectedStoreData($event)"
              [sendToStoreSuccess]="isSendToStore" (clearAllData)="isSendToStore=false">
            </iposcen-send-to-segment-account>

          </div>
        </div>

        <!-- Data Footer - Pagination -->
        <div id="dataFooter" class="data_footer">
          <nav aria-label="promo content pagination"
            *ngIf="displayPromoContentGroups && displayPromoContentGroups?.length">
            <ngb-pagination [collectionSize]="displayPromoContentGroups.length" [(page)]="page" [pageSize]="pageSize"
              [rotate]="true" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"></ngb-pagination>
          </nav>
        </div>
      </div>
      <div id="btnWrapper" class="button-wrapper justify-content-end" *ngIf="presentPage === profilePage">
        <button type="button" class="btn btn-outline-primary gtmAssetLibraryPromoContentSkip"
          (click)="sendToProfile('skip')">
          <span i18n="@@banner-carousel.footer.skip">Skip</span>
        </button>
        <button type="button" class="btn btn-primary gtmAssetLibraryPromoContentSaveAndProceed"
          (click)="sendToProfile('send')" [disabled]="displayPromoContentGroups?.length === 0">
          <span class="gtmAssetLibraryPromoContentSaveAndProceed"
            i18n="@@logo-content.logo-content-groups.save-and-continue">Save and
            Continue</span>
        </button>
      </div>
    </div>
  </section>
  <!-- Create New promo section -->
  <section *ngIf="tabIndex === 1 || tabIndex === 2 || tabIndex === 3 || tabIndex === 4"
    class="main_section al_newpromo">
    <ng-container>
      <div id="tab1" *ngIf="tabIndex === 1">
        <iposcen-create-promo-content [isNavigated]="isNavigated" (goBacktoPromoContent)="setCreatedGrpID($event)">
        </iposcen-create-promo-content>
      </div>
      <div id="tab2" *ngIf="tabIndex === 2">
        <iposcen-page #page1 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=1
          [mediaObjs]="mediaObjects" [disableColors]="disableFields()" (goBacktoLogoContent)="refreshPromoContentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
      <div id="tab3" *ngIf="tabIndex === 3">
        <iposcen-page #page2 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=2
          [mediaObjs]="mediaObjects" [disableColors]="disableFields()" (goBacktoLogoContent)="refreshPromoContentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
      <div id="tab4" *ngIf="tabIndex === 4">
        <iposcen-page #page3 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=3
          [mediaObjs]="mediaObjects" [disableColors]="disableFields()" (goBacktoLogoContent)="refreshPromoContentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
    </ng-container>
    <div id="addBtn" class="button-wrapper mb-4 mr-4 footer-btn"
      *ngIf="tabIndex === 2 || tabIndex === 3|| tabIndex === 4">
      <button type="button" class="btn btn-outline-primary left_icon_btn gtmAddPagePromo" (click)="addPage()"
        *ngIf="!isPage3Created">
        <img src="assets/images/plus_square_outline.svg" alt="add page" />
        <span i18n="@@banner-carousel.footer.add-page">Add Page</span>
      </button>
      <button type="button" class="btn btn-primary gtmSavePromoContGrp"
        (click)="pageError.get(1)||pageError.get(2)||pageError.get(3)?openPopup(errorPopup):updatePromoContent()">
        <span class="gtmSavePromoContGrp">{{buttonName}}</span>
      </button>
      <iposcen-showon-device #showModal (show)="showOnDevice()" (closePopup)="closeShowOnDevice()">
      </iposcen-showon-device>
      <iposcen-apply-changes-to-devices #applyModal (apply)="applyToDevice(true)" (closePopup)="applyToDevice(false)">
      </iposcen-apply-changes-to-devices>
    </div>
  </section>
</div>
<!-- //popup page delete  -->
<ng-template #delete let-modal>
  <div id="confrmPopUp" class="card confirmPopup">
    <div id="modalHeader" class="modal-header">
      <div id="modalCloseIcon" (click)="modal.close()" class="close-icon">
        <img src="../../../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="modalBody" class="modal-body popup-body">
      <div id="modalBodyTitle">
        <h2 class="mt-3">
          <span i18n="@@create-partner-content.delete-modal.delete-page?">Delete Page?</span>
        </h2>
        <div id="modalBodyText" class="card-desc">
          <span i18n="@@create-partner-content.delete-modal.remove-permanently">This content will be removed
            permanently.</span>
        </div>
      </div>
    </div>
    <div id="modalFooter" class="modal-footer card-footer">
      <button type="button" (click)="modal.close()" class="btn btn-outline-primary btn-cancel">
        <span i18n="@@create-partner-content.delete-modal.cancel">Cancel</span>
      </button>
      <button type="button" class="btn btn-primary btn-confirm" (click)="modal.close();deletePages(whichPageDelete)">
        <span i18n="@@create-partner-content.delete-modal.delete-page">Delete Page</span>
      </button>
    </div>
  </div>
</ng-template>
<ng-template #errorPopup let-modal>
  <div id="confirmPopupCard" class="card confirmPopup">
    <div id="confirmPopupHeader" class="modal-header">
      <div id="confirmClose" (click)="modal.close()" class="close-icon">
        <img src="../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="confirmModalBody" class="modal-body popup-body">
      <div id="confirmSec">
        <div id="confirmDesc" class="card-desc">
          <span *ngIf='pageError.get(1) && !pageError.get(2) && !pageError.get(3)'>{{errorMessageText}}</span>
          <span *ngIf='pageError.get(1) && pageError.get(2)  && !pageError.get(3)'>{{errorMessageText1}}</span>
          <span *ngIf='pageError.get(1) && pageError.get(3)  && !pageError.get(2)'>{{errorMessageText2}}</span>
          <span *ngIf='pageError.get(2) && !pageError.get(3) && !pageError.get(1)'>{{errorMessageText3}}</span>
          <span *ngIf='pageError.get(2) && pageError.get(3)  && !pageError.get(1)'>{{errorMessageText4}}</span>
          <span *ngIf='pageError.get(3) && !pageError.get(1) && !pageError.get(2)'>{{errorMessageText5}}</span>
          <span *ngIf='pageError.get(3) && pageError.get(1) && pageError.get(2)'>{{errorMessageText6}}</span>
        </div>
      </div>
    </div>
    <div id="modalFooter" class="modal-footer card-footer">
      <button type="button" (click)="modal.close();goToErrorPage()" class="btn btn-primary btn-confirm">
        <span>{{buttonLable}}</span>
      </button>
    </div>
  </div>
</ng-template>